<template>
    <div class="space-y-4">

        <label
            v-if="$slots.default || inputLabel"
            :for="'input' + _uid"
            class="text-body-sm font-semibold text-black"
        >
            <slot>{{ capitaliseFirst(inputLabel) }}</slot>
        </label>

        <p v-if="error" class="text-semantic-error inline-flex gap-4">
            <svg-icon
                type="error"
                class="w-16 h-16"
            />
            <span class="text-body-sm">{{ capitaliseFirst(error) }}</span>
        </p>

        <div
            class="border bg-white rounded flex overflow-hidden has-[:focus]:border-semantic-info has-[:disabled]:border-primary-20 has-[:disabled]:bg-primary-5 has-[:disabled]:text-primary-60"
            :class="[ error ? 'border-semantic-error' : 'border-primary-80']"
            @click="focus"
        >
            <textarea
                ref="input"
                :id="'input' + _uid"
                v-model="inputValue"
                :class="[ disabled ? 'cursor-not-allowed' : '']"
                :disabled="disabled"
                :placeholder="placeholder"
                :name="name"
                class="flex-grow p-16 placeholder-primary-80 outline-none min-h-128"
                @focus="$emit('focus')"
                @focusout="$emit('focusout')"
            ></textarea>
        </div>
    </div>
</template>

<script>
import {ucfirst} from "../../../shared/helpers";
import SvgIcon from "../ui/SvgIcon.vue";

export default {
    name: 'TextArea',
    components: {SvgIcon},
    props: {
        value: {
            default: '',
        },
        placeholder: {
            default: '',
        },
        name: String,
        autofocus: Boolean,
        disabled: Boolean,
        errors: Array,
        inputLabel: String,
    },
    data: function () {
        return {
            isFocused: false,
        }
    },
    computed: {
        inputValue: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            }
        },
        error() {
            if (!this.errors) {
                return null;
            }

            return Array.isArray(this.errors) ? this.errors[0] : this.errors;
        },
    },
    methods: {
        capitaliseFirst(text = '') {
            return ucfirst(text);
        },
        focus () {
            this.$refs.input.focus();
        },
    },
    mounted () {
        if (this.autofocus) {
            this.focus();
        }
    }
}
</script>
